module.exports = __webpack_public_path__ + "images/emoji/raising_hand.f5b780dfc3169a49ea2a.png";